import React from 'react';
import styles from './CardGroup.module.css';

export interface CardGroupProps {
  cols?: number | string;
  children?: React.ReactNode;
  className?: string;
}

export const CardGroup: React.FC<CardGroupProps> = ({
  cols = 2,
  children,
  className = '',
}) => {
  const colCount = Number(cols) || 2;
  const colsClass =
    colCount === 1
      ? styles.cols1
      : colCount === 3
        ? styles.cols3
        : colCount === 4
          ? styles.cols4
          : styles.cols2;

  return <div className={`${styles.group} ${colsClass} ${className}`.trim()}>{children}</div>;
};

export default CardGroup;
